<template>
    <div class="chat-modal-header">
        <transition name="fade1">
            <div class="tr a" key="a" v-if="!open_message">
                <div class="b">Chat with us!</div>
                <!-- <span class="n">with Pcbcart</span> -->
            </div>
            <div class="tr" key="b" v-else>
                <div class="arrow-left">
                    <a @click="close()" href="#"></a>
                </div>
                <div class="message-header">
                    <span class="online-cyc" :class=" super_admin_online.length > 0 ? 'ac' : ''"></span>
                    <img src="../assets/avatar.png" alt="">
                    <!-- <svg viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" >
                        <path style="fill:#FDBD40;" d="M288.094,447.462c1.314,3.593,1.997,7.381,2.039,11.204c-0.026,1.971-0.222,3.934-0.597,5.871  c103.501-16.606,179.661-105.847,179.797-210.671c-0.051-0.478-0.154-0.947-0.282-1.408c-5.367,2.901-11.042,5.188-16.922,6.827  C449.425,353.143,380.706,431.974,288.094,447.462z"/>
                        <g>
                            <path style="fill:#36AFAD;" d="M98.133,104.533v-12.8H82.065C36.762,91.785,0.051,128.495,0,173.798v6.537   c0.051,45.303,36.762,82.014,82.065,82.065h16.503c-0.154-2.842-0.435-5.649-0.435-8.533V104.533z"/>
                            <path style="fill:#36AFAD;" d="M429.935,91.733h-16.068v162.133c0,2.884-0.282,5.692-0.435,8.533h16.504   c45.312-0.026,82.039-36.753,82.065-82.065v-6.537C511.949,128.495,475.238,91.785,429.935,91.733z"/>
                        </g>
                        <path style="fill:#FFD782;" d="M413.867,104.533H98.133v149.333c0,2.884,0.282,5.692,0.435,8.533  c4.531,86.955,78.686,153.771,165.641,149.239c80.623-4.198,145.041-68.617,149.239-149.239c0.154-2.842,0.435-5.649,0.435-8.533  L413.867,104.533z M145.067,185.6c0-18.85,15.283-34.133,34.133-34.133s34.133,15.283,34.133,34.133s-15.283,34.133-34.133,34.133  S145.067,204.45,145.067,185.6z M347.366,294.033c-50.458,50.458-132.275,50.458-182.733,0c-3.277-3.388-3.183-8.789,0.213-12.066  c3.311-3.191,8.55-3.191,11.853,0c43.802,43.793,114.799,43.793,158.601,0c3.388-3.277,8.789-3.183,12.066,0.205  C350.558,285.483,350.558,290.722,347.366,294.033z M332.8,219.733c-18.85,0-34.133-15.283-34.133-34.133  s15.283-34.133,34.133-34.133s34.133,15.283,34.133,34.133S351.65,219.733,332.8,219.733z"/>
                        <path style="fill:#E97424;" d="M288.094,447.462c-4.736-13.687-17.613-22.886-32.094-22.929h-8.533  c-18.85,0-34.133,15.283-34.133,34.133s15.283,34.133,34.133,34.133H256c16.555-0.043,30.686-11.955,33.536-28.262  c0.375-1.937,0.572-3.9,0.597-5.871C290.091,454.844,289.408,451.055,288.094,447.462z"/>
                        <circle style="fill:#FDBD40;" cx="179.2" cy="185.6" r="17.067"/>
                        <path style="fill:#E97424;" d="M213.333,185.6c0-18.85-15.283-34.133-34.133-34.133s-34.133,15.283-34.133,34.133  s15.283,34.133,34.133,34.133S213.333,204.45,213.333,185.6z M162.133,185.6c0-9.429,7.637-17.067,17.067-17.067  c9.429,0,17.067,7.637,17.067,17.067c0,9.429-7.637,17.067-17.067,17.067C169.771,202.667,162.133,195.029,162.133,185.6z"/>
                        <circle style="fill:#FDBD40;" cx="332.8" cy="185.6" r="17.067"/>
                        <g>
                            <path style="fill:#E97424;" d="M332.8,151.467c-18.85,0-34.133,15.283-34.133,34.133s15.283,34.133,34.133,34.133   s34.133-15.283,34.133-34.133S351.65,151.467,332.8,151.467z M332.8,202.667c-9.429,0-17.067-7.637-17.067-17.067   c0-9.429,7.637-17.067,17.067-17.067s17.067,7.637,17.067,17.067C349.867,195.029,342.229,202.667,332.8,202.667z"/>
                            <path style="fill:#E97424;" d="M335.3,281.967c-43.802,43.793-114.799,43.793-158.601,0c-3.388-3.277-8.789-3.183-12.066,0.213   c-3.191,3.311-3.191,8.55,0,11.853c50.458,50.458,132.275,50.458,182.733,0c3.277-3.388,3.183-8.789-0.205-12.066   C343.851,278.775,338.611,278.775,335.3,281.967z"/>
                        </g>
                        <path style="fill:#195C85;" d="M98.133,104.533h315.733V57.6c-0.026-21.197-17.203-38.374-38.4-38.4H136.533  c-21.197,0.026-38.374,17.203-38.4,38.4V104.533z"/>
                    </svg> -->
                    <div class="b">PCBCart</div>
                    <span class="n">Support Team</span>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
    computed: {
        ...mapState(['open_modal', 'open_message', 'user', 'super_admin_online']),
        ...mapState('chatList', ['list'])
    },
    methods: {
        ...mapMutations(['closeMessage']),
        ...mapMutations('chatList', ['showChatLoading']),
        ...mapMutations('messageList', ['updateMessagePage']),
        close() {
            this.updateMessagePage({ last_page: 0, current_page: 0 })
            this.showChatLoading()
            if (this.user.uuid) {
                this.$remote.$emit('getconversations', this.user)
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.chat-modal-header { z-index: 2147483001; position: absolute; top: 0; right: 0; left: 0; height: 75px; text-align: left;
    background-color: #286efa; box-shadow: 0 1px 4px rgba(0,0,0,.2); color:#fff; font-size: 15px;
    div.b {margin-bottom: 2px;}
    span.n { color: hsla(0,0%,100%,.8); font-size: 13px; line-height: 1.1em; }
    .arrow-left {position: absolute; top: 0; left: 0; background-image: url('../assets/arrow-left.png'); background-size: 8px 13px;
      background-repeat: no-repeat; background-position: 50%; width: 75px; height: 75px;
      a { display: block; margin: 13px; width: 50px; height: 50px; padding: 8px; border-radius: 8px;}
      &:hover {
        a { background-color: rgba(0,0,0,.1);}
      }
    }
    .message-header { position: absolute; left: 75px; top: 0; display: flex; align-items: flex-start; flex-direction: column;
      justify-content: center; padding-left: 45px; height: 100%;
      .online-cyc { position: absolute; border-radius: 50%; transition: all .2s cubic-bezier(.42,0,.58,1); opacity: 1; display: block;z-index: 2;
            background-color: #ccc; border: 2px solid #fff; width: 11px; height: 11px; top: 46px; left: 26px;;
            &.ac { background-color: #39c05c;}
        }
      img, svg {position: absolute; left: 0; top: 21.5px; width: 35px; height: 35px;}
      img { border-radius: 50%;}
    }
    .tr { position: absolute; left: 0; top: 0; bottom: 0; right: 0;
      &.a { padding: 0 40px; align-items: flex-start; justify-content: center; display: flex; flex-direction: column;}
    }
}
.fade1-enter-active, .fade1-leave-active {
  transition: all .25s;
}
.fade1-enter, .fade1-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0; transform: translateX(5px);
}
</style>


// WEBPACK FOOTER //
// src/components/ChatHeader.vue